import { takeEvery, put, take } from "redux-saga/effects";//header
//header
import { GET_HEADER_DATA } from "../../common/Header/store/actionTypes";
import { setHeaderData } from "../../common/Header/store/actionCreators";

import axios from "axios"

function* mySaga() {
    yield takeEvery(GET_HEADER_DATA, _getHeaderData)
}

function* _getHeaderData(e) {
    if (e.data) {
        yield put(setHeaderData(e.data))
    }
}

export default mySaga
